import { store } from "@/stores";

/**
 * Định dạng SĐT mà authen-service chấp nhận khi sinh OTP.
 * Phải khớp đúng regex phía BE (`OTPServiceImpl.isValidPhoneNumber`):
 *   ^(0|\+84)([35789])\d{8}$
 * Gửi chuỗi không khớp thì BE bỏ qua bước sinh mã và trả về "otpCode is null".
 */
export const VN_PHONE_PATTERN = /^(0|\+84)[35789]\d{8}$/;

/** Thông báo dùng chung khi hồ sơ người dùng không có SĐT hợp lệ để nhận OTP. */
export const MISSING_OTP_PHONE_MESSAGE =
  "Tài khoản chưa có số điện thoại hợp lệ để nhận OTP. Vui lòng cập nhật hồ sơ hoặc liên hệ quản trị viên.";

/** Chuẩn hoá và kiểm tra một giá trị bất kỳ có phải SĐT hợp lệ để nhận OTP không. */
export const isValidOtpPhone = (value?: unknown): boolean =>
  VN_PHONE_PATTERN.test(String(value ?? "").trim());

/**
 * SĐT dùng làm `phoneNumber` khi gọi `generateOTP`.
 *
 * Nguồn dữ liệu, xét theo thứ tự:
 *   1. `auth.user.primaryPhone` — hồ sơ người đang đăng nhập, nguồn chuẩn nhất.
 *   2. `localStorage["primaryPhone"]` — lưu lúc login (`LoginWrapper`), dùng khi
 *      profile chưa kịp về store.
 *   3. `localStorage["userName"]` — chỉ đúng khi user đăng nhập bằng chính SĐT.
 *      Giữ lại vì luồng đăng nhập bằng QR (`LoginByApp`) mới chỉ lưu `userName`.
 *
 * Cách chọn:
 *   - Ưu tiên giá trị ĐẦU TIÊN khớp {@link VN_PHONE_PATTERN} — chắc chắn BE sinh được mã.
 *   - Không có giá trị nào khớp thì lấy giá trị đầu tiên khác rỗng, chấp nhận để BE
 *     tự từ chối. Chủ ý giữ vậy để không chặn các luồng vốn đang chạy được, thay vì
 *     dừng ngay ở FE.
 *   - Rỗng hoàn toàn mới trả về "" — lúc đó call site nên dừng luồng và báo
 *     {@link MISSING_OTP_PHONE_MESSAGE}.
 *
 * Lưu ý: đọc store theo kiểu imperative nên chỉ gọi trong event handler / hàm async,
 * không gọi trong thân render.
 */
export const getOtpPhoneNumber = (): string => {
  const candidates = [
    store.getState().auth.user?.primaryPhone,
    localStorage.getItem("primaryPhone"),
    localStorage.getItem("userName"),
  ].map((candidate) => String(candidate ?? "").trim());

  return (
    candidates.find((phone) => VN_PHONE_PATTERN.test(phone)) ??
    candidates.find((phone) => phone !== "") ??
    ""
  );
};

export default getOtpPhoneNumber;
